import React from "react";
import {useSelector} from "react-redux";
import styled, {css} from "styled-components";
import Link from "./Link";
import InputSearch from "../inputs/InputSearch";
import useFilterUser from "../../custom-hooks/useFilterUser";

const Links = () => {
    const {links} = useSelector(state => state.project)

    const {
        query,
        setQuery,
        getFullNameInverseNoWhiteSpace,
        getFullNameNoWhiteSpace,
        getQueryNoWhiteSpace,
    } = useFilterUser()
    return (
        <Container>
            <InputSearch
                setQuery={setQuery}
                placeholder={"nom du lien, de l'auteur..."}
            />
            {links.length > 0 ?
                <TableContainer>
                    <Table>
                        <thead>
                        <tr>
                            <Th primary>Libellé</Th>
                            <Th secondary>Envoyé par </Th>
                            <Th tertiary> Actions </Th>
                        </tr>
                        </thead>
                        <Tbody>
                            {links
                                .filter(l =>
                                    l.name.toLowerCase().includes(query.toLowerCase()) ||
                                    getFullNameNoWhiteSpace(l.author).includes(getQueryNoWhiteSpace(query)) ||
                                    getFullNameInverseNoWhiteSpace(l.author).includes(getQueryNoWhiteSpace(query)))
                                .map(l => (
                                    <tr key={l.name + '/' + l.id}>
                                        <Link
                                            id={l.id}
                                            name={l.name}
                                            url={l.url}
                                            author={l.author}
                                        />
                                    </tr>
                                ))}
                        </Tbody>
                    </Table>
                </TableContainer>

                :
                <p className={"txt-align"}> Aucune ressource n'a été ajoutée pour le moment </p>
            }
        </Container>
    )
}


const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  justify-content: center;
  padding-bottom: 2rem;
`

const TableContainer = styled.div`
  overflow: auto;
  @media (min-width: 800px) {
    height: 370px;
  }
`
const Table = styled.table`
  overflow-y: auto;
  padding-top: 2rem;
  height: fit-content;
`
const Th = styled.th`
  border-bottom: 1px solid var(--color-grey-03);
  padding-bottom: 1rem;
  padding-right: 1rem;
  text-align: left;
  ${props => props.primary && css`
    width: 500px;
  `}
  ${props => props.secondary && css`
    width: 250px;
  `}
  ${props => props.tertiary && css`
    width: 100px;
    text-align: center;
  `}
  
`

const Tbody = styled.tbody`
  overflow-y: auto;
`

export default Links